module.exports = __webpack_public_path__ + "static/Oculus-e9d7d5dc687c4c6852672f16aae44ede.jpg";